import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchAuthSession } from "aws-amplify/auth";
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL || "http://localhost:3001",
  prepareHeaders: async (headers) => {
    try {
      const session = await fetchAuthSession();
      if (session.tokens?.idToken?.toString()) {
        headers.set(
          "Authorization",
          `Bearer ${session.tokens.idToken.toString()}`
        );
      }
    } catch (err) {
      console.error({ err });
    }
    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ["User", "Payment", "Circle", "CircleMembers", "Status", "Profile", "Notification", "VerificationStatus", "BankAccounts", "OnboardingStatus", "PaymentHistory", "TosAcceptance"],
  endpoints: () => ({}),
});
